<script>
import { isPresent } from "@/lib/utils"
import { parseWorkoutUnits } from "@/lib/workout-utils"

import {
  formatUnitType,
  formatItemUnits,
  formatIntensityUnitType
} from "@/lib/workout-utils"

export default {
  functional: true,

  props: {
    item: { type: Object, required: true },
    noStyling: { type: Boolean, default: false }
  },

  render(h, { props, data }) {
    const classes = ["group-item-details", data.staticClass, data.class]
    const spanClass = props.noStyling ? "" : "opacity-60"

    const hasIntensityDetails = isPresent(props.item.intensity_type)

    const intUnits = parseWorkoutUnits(props.item.units)

    const hasDetails =
      intUnits > 0 || props.item.sets > 1 || hasIntensityDetails

    if (!hasDetails) return null

    const formattedUnitType =
      intUnits > 0 ? formatUnitType(props.item.unit_type, intUnits) : ""

    const formattedIntensityUnitType = props.item.intensity_type
      ? formatIntensityUnitType(props.item.intensity_type)
      : ""

    return (
      hasDetails && (
        <span class={classes}>
          <span class="group-item-details__units">
            {props.item.sets > 1 && <span>{props.item.sets}&nbsp;x&nbsp;</span>}
            {intUnits > 0 && (
              <span
                domPropsInnerHTML={formatItemUnits(
                  props.item.unit_type,
                  props.item.units
                )}
              ></span>
            )}
            {intUnits > 0 && (
              <span class={spanClass}>{formattedUnitType}&nbsp;</span>
            )}
          </span>
          {isPresent(props.item.intensity_type) &&
            isPresent(props.item.intensity_units) && (
              <span class="group-item-details__intensity">
                {intUnits > 0 && <span class={spanClass}>@&nbsp;</span>}
                <span>{props.item.intensity_units}&nbsp;</span>
                <span class={spanClass}>{formattedIntensityUnitType}</span>
              </span>
            )}
        </span>
      )
    )
  }
}
</script>
